import { render, staticRenderFns } from "./tab-selector.vue?vue&type=template&id=6a13500e&scoped=true&"
import script from "./tab-selector.vue?vue&type=script&lang=ts&"
export * from "./tab-selector.vue?vue&type=script&lang=ts&"
import style0 from "./tab-selector.vue?vue&type=style&index=0&id=6a13500e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13500e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
